import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const RCPA = () => {
  const data = [
    ['Customer', 'Pre-call Activity'],
    ['Customer 1', 5],
    ['Customer 2', 7],
    ['Customer 3', 6],
    ['Customer 4', 8],
    ['Customer 5', 4],
  ];

  const options = {
    title: 'RCPA (Retail Chemist Prescription Audit)',
    hAxis: { title: 'Customer' },
    vAxis: { title: 'Pre-call Activity' },
    legend: { position: 'top' },
    bar: { groupWidth: '75%' },
    colors: ['#4CAF50'],
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="ColumnChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default RCPA;